import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Typography } from '@one-thd/sui-atomic-components';
import { InteriorCornersNote } from './OptionGroupNotes';

const ChooseInteriorAnglesOptionGroup = ({ children, totalInteriorCorners }) => children.length > 0
&& totalInteriorCorners > 0 && (
  <div id="ChooseInteriorAngles" className="card-content flex-wrap-dependent-options">
    <div className="row-header">
      <div className="row-header__title">
        <Typography variant="h2" className="sui-border-none">
          <div id={`Option_${children[0].props.option.id}`}>
            Interior Angles
          </div>
        </Typography>
      </div>
    </div>
    <div className="subQuestion">
      <span>
        {`${'Select whether your countertop\'s interior angles should be 90 or 45 degrees.  '}`}
      </span>
      <InteriorCornersNote />
    </div>
    <div className="flex-wrap-dependent-options dependent-options">{children}</div>
  </div>
);

ChooseInteriorAnglesOptionGroup.propTypes = {
  children: PropTypes.node.isRequired,
  totalInteriorCorners: PropTypes.number,
};
ChooseInteriorAnglesOptionGroup.defaultProps = {
  totalInteriorCorners: 0,
};

const mapStateToProps = (state) => ({
  totalInteriorCorners: state.draftingTool.totalInteriorCorners,
});
export default connect(mapStateToProps)(ChooseInteriorAnglesOptionGroup);
